module.exports = __webpack_public_path__ + "static/media/Open-Sans-regular.d0bad741.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Open-Sans-regular/Open-Sans-regular.woff
// module id = 415
// module chunks = 0